import { createSlice } from "@reduxjs/toolkit";
import {
  getRadioTracksBuilder,
  createRadioTrackBuilder,
  reorderRadioTracksBuilder,
  updateRadioTrackBuilder,
  toggleRadioTrackBuilder,
  deleteRadioTrackBuilder,
} from "./builder";

const initialState = {
  tracks: {
    data: [],
    loading: false,
    createLoading: false,
    deleteLoading: false,
    toggleLoading: false,
    error: null,
  },
};

const radioSlice = createSlice({
  name: "radio",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getRadioTracksBuilder(builder);
    createRadioTrackBuilder(builder);
    reorderRadioTracksBuilder(builder);
    updateRadioTrackBuilder(builder);
    toggleRadioTrackBuilder(builder);
    deleteRadioTrackBuilder(builder);
  },
});

export const selectRadioTracks = (state) => state.radioInfo.tracks;

export default radioSlice.reducer;
